import { createContext, useContext, useEffect, useState } from "react";

const ModeContext = createContext({ mode: "premium", setMode: () => {} });

function initialMode() {
  const saved = localStorage.getItem("pc-mode");
  if (saved === "premium" || saved === "light") return saved;
  const reduce = window.matchMedia?.("(prefers-reduced-motion: reduce)").matches;
  const saveData = navigator.connection?.saveData;
  const weak = (navigator.deviceMemory && navigator.deviceMemory <= 2) || (navigator.hardwareConcurrency && navigator.hardwareConcurrency <= 2);
  return reduce || saveData || weak ? "light" : "premium";
}

export function ModeProvider({ children }) {
  const [mode, setModeState] = useState(initialMode);
  useEffect(() => { document.documentElement.dataset.mode = mode; }, [mode]);
  const setMode = (m) => { localStorage.setItem("pc-mode", m); setModeState(m); };
  return <ModeContext.Provider value={{ mode, setMode }}>{children}</ModeContext.Provider>;
}

export const useMode = () => useContext(ModeContext);
